import { render, staticRenderFns } from "./StatisticsOfOffers.vue?vue&type=template&id=1807ff60&scoped=true&"
import script from "./StatisticsOfOffers.vue?vue&type=script&lang=js&"
export * from "./StatisticsOfOffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1807ff60",
  null
  
)

export default component.exports